import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import useReveal from "@/lib/useReveal";
import { hideEmergentBadge } from "@/lib/hideBadge";
import { initGtag } from "@/lib/gtag";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import CompletedProjects from "@/components/site/CompletedProjects";
import CinematicSlider from "@/components/site/CinematicSlider";
import Highlights from "@/components/site/Highlights";
import Plots from "@/components/site/Plots";
import VillaTypes from "@/components/site/VillaTypes";
import Amenities from "@/components/site/Amenities";
import MapSection from "@/components/site/MapSection";
import EnquiryForm from "@/components/site/EnquiryForm";
import Footer from "@/components/site/Footer";
import FloatingCTA from "@/components/site/FloatingCTA";
import ThankYou from "@/components/site/ThankYou";
import PrivacyPolicy from "@/components/site/PrivacyPolicy";
import NriHome from "@/pages/NriHome";

const Home = () => {
  useReveal();
  const [preselected, setPreselected] = useState("");

  useEffect(() => {
    hideEmergentBadge();
    initGtag();
  }, []);

  const handleEnquire = (item) => {
    setPreselected(item?.name || "");
    const el = document.getElementById("enquiry");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="home-page" className="bg-[#F7F5F0] text-[#1C1C1C]">
      <Header />
      <main>
        <Hero />
        <CompletedProjects />
        <CinematicSlider />
        <Highlights />
        <Plots onEnquire={handleEnquire} />
        <VillaTypes onEnquire={handleEnquire} />
        <Amenities />
        <MapSection />
        <EnquiryForm preselected={preselected} />
      </main>
      <Footer />
      <FloatingCTA />
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/nri" element={<NriHome />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
